import React from "react"
import PropTypes from "prop-types"
import MessageBox from "@/components/MessageBox"
import { withApi } from "@tencent/react-aio"
import _ from "lodash"
import Dialog from "@/components/Dialog"
import { FormGroup, RadioGroup, Select } from "@tencent/spaui"
import { enumMessages } from "@/utils/MessageUtils"

const reviewPass = "REVIEW_STATUS_PASSED"
const reviewReject = "REVIEW_STATUS_REJECTED"

class OnlineReviewModal extends React.Component {
  static propTypes = {
    orderInfo: PropTypes.object.isRequired,
    version: PropTypes.number.isRequired,
    onSubmit: PropTypes.func,
  }

  state = {}

  render() {
    const { orderInfo } = this.props
    const { reviewStatus, comments, error } = this.state
    const config = this.getMessages("ReviewStatus")

    return (
      <Dialog className="OnlineReviewModal" title="上线确认" subTitle={orderInfo.lead.company.companyName} style={{ width: 640 }} {...this.props} onSubmit={this.onSubmit}>
        <div className="RadioGroup">
          <span>审核结果：</span>
          <RadioGroup data={config} value={reviewStatus} onChange={this.handleChange} />
        </div>

        {reviewStatus === reviewPass && (
          <React.Fragment>
            <p>
              <label>客户名称：</label>
              {orderInfo.remittanceAccountName}
            </p>
            <p>
              <label>首次到款金额：</label>
              {orderInfo.firstPaymentAmount}
            </p>
            <p>
              <label>服务费：</label>
              {orderInfo.serviceFee}
            </p>
            <p>
              <label>备注：</label>
            </p>
            <textarea rows={4} cols={30} className="spaui-input" value={comments} onChange={this.handleCommentsChange} placeholder={"备注"} />
            <p>
              <label>确认上线？</label>
            </p>
          </React.Fragment>
        )}

        {reviewStatus === reviewReject && (
          <React.Fragment>
            <FormGroup className={"required with-select"}>
              <label className="required">备注：</label>
              <textarea rows={4} cols={30} className="spaui-input" value={comments} onChange={this.handleCommentsChange} placeholder={"驳回原因/备注"} />
            </FormGroup>
          </React.Fragment>
        )}

        {error && (
          <p className={"has-error"}>
            <span className={"error-message"}>发生错误：{error.message || "服务器错误"}</span>
          </p>
        )}
      </Dialog>
    )
  }

  getMessages = (key) => {
    return _.compact(
      _.map(enumMessages(key), (message) => {
        return {
          value: message.value,
          children: message.message,
        }
      })
    )
  }

  handleChange = (event, value) => {
    this.setState({
      reviewStatus: value,
      error: null,
    })
  }

  handleCommentsChange = (event) => {
    this.setState({
      comments: event.target.value,
    })
  }

  onSubmit = () => {
    const { webApi } = this.props
    const { orderInfo: order } = this.props
    const { reviewStatus, comments } = this.state

    if (!reviewStatus) {
      this.setState({
        error: {
          message: "审核状态必填",
        },
      })
      return
    }

    //数据校验
    if (reviewStatus && reviewStatus === reviewReject) {
      if (!comments) {
        this.setState({
          error: {
            message: "备注必填",
          },
        })
        return
      }
    }

    const params = {
      orderId: order.orderId,
      leadId: order.leadId,
      reviewStatus: reviewStatus,
      comments: comments,
      version: this.props.version,
    }

    webApi
      .reviewOrderEffective()
      .ajaxJson({ data: params })
      .then(
        () => {
          this.context.success("上线审核成功")
          this.props.onSubmit()
          this.props.refreshTable()
        },
        (error) => {
          this.context.error("上线审核失败", error.message)
          this.props.onSubmit()
        }
      )
  }
}

export default withApi(OnlineReviewModal)

OnlineReviewModal.contextType = MessageBox
